import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

const useCustomerInfoFormStyles = makeStyles({
    root: {
        width: '100%'
    },
    inquiryContactInfo: {
        display: 'grid',
        gridTemplateColumns: 'repeat(6, 1fr)',
        gridTemplateRows: 'repeat(5, 1fr)',
        columnGap: tokens.spacingHorizontalXXL,
        rowGap: tokens.spacingVerticalM,
        width: '100%',
        '@media screen and (max-width: 480px)': {
            display: 'flex',
            flexDirection: 'column'
        }
    },
    firstNameContainer: { ...shorthands.gridArea('1', '1', '2', '4') },
    lastNameContainer: { ...shorthands.gridArea('1', '4', '2', '7') },
    address1Container: { ...shorthands.gridArea('2', '1', '3', '7') },
    address2Container: { ...shorthands.gridArea('3', '1', '4', '7') },
    cityContainer: { ...shorthands.gridArea('4', '1', '5', '3') },
    stateContainer: { ...shorthands.gridArea('4', '3', '5', '5'), minWidth: 'unset' },
    zipcodeContainer: { ...shorthands.gridArea('4', '5', '5', '7') },
    phoneNumberContainer: { ...shorthands.gridArea('5', '1', '5', '4') }
});

export default useCustomerInfoFormStyles;
